@if (role === 'client') {
@if (categories?.length) {
	<!-- Global select-all/deselect-all (CLIPPING-586 Part 2) - one control for every tag
	     across every section/category, regardless of tagType. Text link, same style/logic
	     as the per-section links below - no checkbox, so it doesn't read as another section. -->
	<div class="select-all-row">
		<button type="button" class="select-all-link" (click)="toggleAllTags(!allTagsChecked())">
			{{ (allTagsChecked() ? 'TAG.DESELECT_ALL' : 'TAG.SELECT_ALL') | translate }}
		</button>
	</div>
}
@if (tagType === 'clipping') {
	@if (brandSplit.hasCompany) {
		<!-- Company section: flat tag list, no category level. The link only shows with more
		     than one tag (same rule as the other sections) - a client usually has just one
		     company tag, so it's typically absent here, but isn't hardcoded off. -->
		<div class="section-header">
			<h3 class="section-label">{{ 'ASSORTED.COMPANY_CATEGORIES' | translate }}</h3>
			@if (brandSplit.company.length > 1) {
			<button type="button" class="select-all-link" (click)="toggleBrandSection(brandSplit.company, !brandSectionChecked(brandSplit.company))">
				{{ (brandSectionChecked(brandSplit.company) ? 'TAG.DESELECT_ALL' : 'TAG.SELECT_ALL') | translate }}
			</button>
			}
		</div>
		<div class="client-tags">
			@for (item of brandSplit.company; track item.tag.id) {
				<mat-checkbox [(ngModel)]="item.tag.checked" (change)="checkItem($event.checked, item.tag, item.category)">
					{{ utils.getParameterByLanguageScript(item.tag, 'name', true) }}
				</mat-checkbox>
			}
		</div>
	}
	@if (brandSplit.hasCompetitor) {
		<!-- Competitor section: flat tag list, no category level -->
		<div class="section-header" [class.section-label-spaced]="brandSplit.hasCompany">
			<h3 class="section-label">{{ 'ASSORTED.COMPETITOR_CATEGORIES' | translate }}</h3>
			@if (brandSplit.competitor.length > 1) {
			<button type="button" class="select-all-link" (click)="toggleBrandSection(brandSplit.competitor, !brandSectionChecked(brandSplit.competitor))">
				{{ (brandSectionChecked(brandSplit.competitor) ? 'TAG.DESELECT_ALL' : 'TAG.SELECT_ALL') | translate }}
			</button>
			}
		</div>
		<div class="client-tags">
			@for (item of brandSplit.competitor; track item.tag.id) {
				<mat-checkbox [(ngModel)]="item.tag.checked" (change)="checkItem($event.checked, item.tag, item.category)">
					{{ utils.getParameterByLanguageScript(item.tag, 'name', true) }}
				</mat-checkbox>
			}
		</div>
	}
	@if (brandSplit.hasThematic) {
		<!-- Thematic section: flat tag list, no category level -->
		<div class="section-header" [class.section-label-spaced]="brandSplit.hasCompany || brandSplit.hasCompetitor">
			<h3 class="section-label">{{ 'ASSORTED.THEMATIC_CATEGORIES' | translate }}</h3>
			@if (brandSplit.thematic.length > 1) {
			<button type="button" class="select-all-link" (click)="toggleBrandSection(brandSplit.thematic, !brandSectionChecked(brandSplit.thematic))">
				{{ (brandSectionChecked(brandSplit.thematic) ? 'TAG.DESELECT_ALL' : 'TAG.SELECT_ALL') | translate }}
			</button>
			}
		</div>
		<div class="client-tags">
			@for (item of brandSplit.thematic; track item.tag.id) {
				<mat-checkbox [(ngModel)]="item.tag.checked" (change)="checkItem($event.checked, item.tag, item.category)">
					{{ utils.getParameterByLanguageScript(item.tag, 'name', true) }}
				</mat-checkbox>
			}
		</div>
	}
	@if (!brandSplit.hasCompany && !brandSplit.hasCompetitor && !brandSplit.hasThematic) {
		<!-- No tags at all: same generic heading non-clipping tag types show -->
		<h3 class="section-label">{{ 'ASSORTED.CATEGORIES' | translate }}</h3>
		<div class="client-tags"></div>
	}
} @else {
	<!-- Single section (non-clipping tag types) -->
	<div class="client-tags">
		@for (category of categories; track $index) {
			<ng-container *ngTemplateOutlet="categoryBlock; context: { $implicit: category }"></ng-container>
		}
	</div>
}

<ng-template #categoryBlock let-category>
	<div class="client-category">
		<div class="client-category-row">
			<mat-icon class="client-chevron" [class.expanded]="category.isOpened" (click)="category.isOpened = !category.isOpened">chevron_right</mat-icon>
			<mat-checkbox [checked]="category.checked" [indeterminate]="indeterminate(category)" (change)="selectAll($event.checked, category)">
				<span class="client-category-label">{{ utils.getParameterByLanguageScript(category, 'name', true) }}</span>
			</mat-checkbox>
		</div>
		@if (category.isOpened) {
			<div class="client-tag-list">
				@for (tag of category.tags; track tag.id) {
					<div class="client-tag-row">
						<mat-checkbox [(ngModel)]="tag.checked" (change)="checkItem($event.checked, tag, category)">
							{{ utils.getParameterByLanguageScript(tag, 'name', true) }}
						</mat-checkbox>
						@if (tagType === 'transcriptions') {
							<mat-icon class="client-tag-delete-icon"
								[class.disabled]="deletingTagFor === tag.id"
								matTooltip="{{ 'BUTTON.DELETE' | translate }}"
								(click)="deleteClientTag(tag, category)">close</mat-icon>
						}
					</div>
				}

				@if (tagType === 'transcriptions') {
					<div class="client-tag-add">
						<mat-icon class="client-tag-add-icon">add</mat-icon>
						<input
							class="client-tag-add-input"
							type="text"
							[(ngModel)]="newTagName[category.id]"
							[placeholder]="'TAG.ADD_TAG' | translate"
							[disabled]="creatingTagFor === category.id"
							(keyup.enter)="createClientTag(category)"
							(blur)="createClientTag(category)" />
					</div>
				}
			</div>
		}
	</div>
</ng-template>
} @else {
<!-- Admin: accordion view -->
<div class="tags-widget-container p-0">
	<mat-accordion #tagsWrapperAccordion="matAccordion" togglePosition="before">
		<mat-expansion-panel [expanded]="tagsWrapperExpanded" id="mainAccordionPanel" class="pb-2">
			@if (categories && categories.length > 0) {
			<mat-expansion-panel-header>
				<mat-panel-title>
					<span>{{ 'TAG.CATEGORIES' | translate }}</span>
				</mat-panel-title>
				<mat-panel-description></mat-panel-description>
			</mat-expansion-panel-header>
			}
			<div class="row mt-2">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'BUTTON.SEARCH' | translate }}</mat-label>
					<input matInput type="text" [formControl]="searchFormControl" />
					<mat-icon class="cursor-pointer" matSuffix (click)="search()">search</mat-icon>
				</mat-form-field>
			</div>

			<mat-accordion #tagsAccordion="matAccordion" multi togglePosition="before">
				@for (category of categories; track $index ) {
				<mat-expansion-panel id="tagsAccordionPanel" (opened)="accordionAction('open', category)" (closed)="accordionAction('close', category)" [expanded]="category.isOpened">
					<mat-expansion-panel-header>
						<mat-panel-title>
							<mat-checkbox [checked]="category.checked" [indeterminate]="indeterminate(category)" (change)="selectAll($event.checked, category)"></mat-checkbox>
							<span>{{ utils.getParameterByName(category, 'value') }}</span>
						</mat-panel-title>
						<mat-panel-description> </mat-panel-description>
					</mat-expansion-panel-header>

					<span class="list-section">
						<ul [id]="'widget-' + utils.getParameterByName(category, 'value')" cdkDropList [cdkDropListData]="category?.tags" (cdkDropListDropped)="tagsDropAssign.drop($event)">
							@for (tag of category.tags; track tag.id) {
							<li class="d-flex align-items-center">
								<mat-checkbox [(ngModel)]="tag.checked" (change)="checkItem($event.checked, tag, category)"> </mat-checkbox>
								<div class="tag-list-item" [style.background-color]="tag.colorCode"></div>
								<span cdkDrag (cdkDragStarted)="tagsDropAssign.onDragStarted(tag, selectedItems)" (cdkDragReleased)="deselectAll()">
									{{ tag.value }}
								</span>
							</li>
							}
						</ul>
					</span>
				</mat-expansion-panel>
				}
			</mat-accordion>
		</mat-expansion-panel>
	</mat-accordion>
</div>
}
